import React, { useState } from 'react';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { UserProfileType } from 'models/user.model';

type Props = {
  show: boolean;
  onClose: () => void;
  refreshUser: () => void;
  user?: UserProfileType;
};

type ChangeNameModalFormType = {
  first_name: string;
  last_name: string;
};
const ChangeNameModal = ({ show, onClose, refreshUser, user }: Props) => {
  const [form, setForm] = useState<ChangeNameModalFormType>({
    first_name: user?.first_name || '',
    last_name: user?.last_name || ''
  });
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    const data = {
      first_name: form.first_name,
      last_name: form.last_name
    };
    try {
      setLoading(true);
      const res = await apiService.put(`user`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Password reset successfully' />);
        refreshUser();
        onClose();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Change Name'
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <div className='flex justify-end gap-3'>
          <Button className='text-xs w-fit' color='primary' variant='outline' onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={!form.first_name || !form.last_name}
            className='text-xs w-fit'
            color='primary'
            loading={loading}
            variant='block'
            onClick={handleUpdate}>
            Confirm
          </Button>
        </div>
      }>
      <div className='flex flex-col gap-6 justify-center items-center'>
        <Input
          className='w-full'
          design='bordered'
          label={'First Name'}
          name='name'
          placeholder={'John '}
          value={form?.first_name}
          onChange={(val) => setForm({ ...form, first_name: val.target.value })}
        />
        <Input
          className='w-full'
          design='bordered'
          label={'Last Name'}
          name='name'
          placeholder={'Doe'}
          value={form?.last_name}
          onChange={(val) => setForm({ ...form, last_name: val.target.value })}
        />
      </div>
    </BaseModal>
  );
};

export default ChangeNameModal;
